import React from "react";
import PropTypes from "prop-types";
import { Box, Typography } from "@mui/material";
import { formatEmpty } from "../../../utils/formatHelpers";

export default function TextPill({
  value,
  backgroundColor,
  color,
  height,
  width,
  borderRadius,
  padding,
  margin,
  variant,
  textShadow
}) {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: backgroundColor || "black_opacity.70",
        color: color || "white_opacity.100",
        height: height || "20px",
        width: width,
        borderRadius: borderRadius || "20px",
        padding: padding,
        margin: margin
      }}
    >
      <Typography
        variant={variant || "label1"}
        sx={{
          letterSpacing: 0,
          textShadow: textShadow && "-1px 0 #5D5F60, 0 1px #5D5F60, 1px 0 #5D5F60, 0 -1px #5D5F60"
        }}>
        {formatEmpty(value)}
      </Typography>
    </Box>
  );
}

TextPill.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string
  ]),
  backgroundColor: PropTypes.string,
  color: PropTypes.string,
  height: PropTypes.string,
  width: PropTypes.string,
  borderRadius: PropTypes.string,
  padding: PropTypes.string,
  margin: PropTypes.string,
  variant: PropTypes.string,
  textShadow: PropTypes.bool
};